
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export const CTASectionHTAG = ({ onContactClick, whiteBg }) => {
  const sectionClass = whiteBg
    ? 'py-24 px-4 lg:px-8 bg-white'
    : 'py-24 px-4 lg:px-8 bg-gradient-to-r from-[#181C25] to-[#212635]';
  const cardClass = whiteBg
    ? 'relative rounded-2xl p-12 lg:p-20 text-center bg-white border border-blue-500/10 overflow-hidden shadow-md'
    : 'relative rounded-2xl p-12 lg:p-20 text-center bg-gradient-to-br from-gray-900 to-gray-800 border border-blue-500/30 overflow-hidden';
  const titleClass = whiteBg
    ? 'text-4xl lg:text-5xl font-montserrat font-bold text-slate-900 mb-6'
    : 'text-4xl lg:text-5xl font-montserrat font-bold text-white mb-6';
  const subtitleClass = whiteBg
    ? 'text-blue-600'
    : 'text-[#0090FF]';
  const descClass = whiteBg
    ? 'text-slate-600 text-lg max-w-2xl mx-auto mb-10'
    : 'text-gray-300 text-lg max-w-2xl mx-auto mb-10';
  const buttonClass = whiteBg
    ? 'inline-flex items-center gap-3 px-10 py-4 bg-blue-600 text-white rounded-lg font-semibold text-lg hover:bg-blue-700 transition-all shadow-md'
    : 'inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg font-semibold text-lg hover:shadow-lg hover:shadow-blue-500/50 transition-all';

  return (
    <section className={sectionClass + ' w-full'}>
      <div className="container mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className={cardClass}
        >
          {/* Background accent */}
          {!whiteBg && (
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500 rounded-full blur-3xl" />
            </div>
          )}

          <div className="relative z-10">
            <h2 className={titleClass}>
              Passez à l'action,<br />
              <span className={subtitleClass} style={whiteBg ? { textShadow: '0 0 0' } : { color: '#0090FF', textShadow: '0 0 20px rgba(0, 144, 255, 0.3)' }}>
                gagnez du temps
              </span>
            </h2>

            <p className={descClass}>
              Contactez HTAG Facility et transformez vos défis en opportunités. Un devis gratuit, aucun engagement.
            </p>

            <motion.button
              onClick={onContactClick}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className={buttonClass}
            >
              Obtenir un devis gratuit
              <ArrowRight className="w-5 h-5" />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASectionHTAG;
